import ProductDescriptionProvider from './hooks/useProductDescription';

import { ProductDescriptionProps } from './@types/ProductDescriptionProps';
import ProductDescriptionContainer from './handles/ProductDescriptionContainer';
import ProductDescriptionTitle from './handles/ProductDescriptionTitle';
import ProductDescriptionText from './handles/ProductDescriptionText';

const ProductDescription = (props: ProductDescriptionProps) => (
	<ProductDescriptionProvider {...props}>
		<ProductDescriptionContainer>
			<ProductDescriptionTitle />
			<ProductDescriptionText />
		</ProductDescriptionContainer>
	</ProductDescriptionProvider>
);

export default ProductDescription;
